import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=bde2f788&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde2f788')) {
      api.createRecord('bde2f788', component.options)
    } else {
      api.reload('bde2f788', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=bde2f788&", function () {
      api.rerender('bde2f788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VutC123rHWFy/JS/comp/openstreetmap.vue"
export default component.exports